import { withAuthenticationRequired } from '@tom-ui/utils'
import { TenantReeferMaxUnpluggedTimeContainer } from '@tom-ui/admin'
import { ReeferMonitoring } from '@tom-ui/operations'

export const ReeferMonitoringPage = withAuthenticationRequired(() => {
  return <ReeferMonitoring maxPluggedOutComponent={<TenantReeferMaxUnpluggedTimeContainer />} />
})
